import {faSort} from '@fortawesome/free-solid-svg-icons/faSort';
import {faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp';
import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown';
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye';
import {faSync} from '@fortawesome/free-solid-svg-icons/faSync';
import {faBan} from '@fortawesome/free-solid-svg-icons/faBan';
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons/faArrowRight';
import {faSave} from '@fortawesome/free-solid-svg-icons/faSave';
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser';
import {faHdd} from '@fortawesome/free-solid-svg-icons/faHdd';
import {faTachometerAlt} from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import {faHeart} from '@fortawesome/free-solid-svg-icons/faHeart';
import {faList} from '@fortawesome/free-solid-svg-icons/faList';
import {faTasks} from '@fortawesome/free-solid-svg-icons/faTasks';
import {faBook} from '@fortawesome/free-solid-svg-icons/faBook';
import {faLock} from '@fortawesome/free-solid-svg-icons/faLock';
import {faSignInAlt} from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import {faThList} from '@fortawesome/free-solid-svg-icons/faThList';
import {faUserPlus} from '@fortawesome/free-solid-svg-icons/faUserPlus';
import {faWrench} from '@fortawesome/free-solid-svg-icons/faWrench';
import {faAsterisk} from '@fortawesome/free-solid-svg-icons/faAsterisk';
import {faFlag} from '@fortawesome/free-solid-svg-icons/faFlag';
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell';
import {faHome} from '@fortawesome/free-solid-svg-icons/faHome';
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {faRoad} from '@fortawesome/free-solid-svg-icons/faRoad';
import {faCloud} from '@fortawesome/free-solid-svg-icons/faCloud';
import {faRedo} from '@fortawesome/free-solid-svg-icons/faRedo';
import {faMoneyCheckAlt} from '@fortawesome/free-solid-svg-icons/faMoneyCheckAlt';
import {faCopy} from '@fortawesome/free-solid-svg-icons/faCopy';
import {faClipboardCheck} from '@fortawesome/free-solid-svg-icons/faClipboardCheck';
import {faMoneyCheck} from '@fortawesome/free-solid-svg-icons/faMoneyCheck';
import {faFolder} from '@fortawesome/free-solid-svg-icons/faFolder';
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import {faAmbulance} from '@fortawesome/free-solid-svg-icons/faAmbulance';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import {library} from '@fortawesome/fontawesome-svg-core';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons/faArrowUp';
import {faArrowDown} from '@fortawesome/free-solid-svg-icons/faArrowDown';
import {faClock} from '@fortawesome/free-solid-svg-icons/faClock';
import {faCaretUp} from "@fortawesome/free-solid-svg-icons/faCaretUp";
import {faCaretDown} from "@fortawesome/free-solid-svg-icons/faCaretDown";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import {faCar} from "@fortawesome/free-solid-svg-icons/faCar";
import {faPhoneAlt} from "@fortawesome/free-solid-svg-icons/faPhoneAlt";
import {faMapMarker} from "@fortawesome/free-solid-svg-icons/faMapMarker";
import {faBus} from "@fortawesome/free-solid-svg-icons/faBus";
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import {faHospital} from "@fortawesome/free-solid-svg-icons/faHospital";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons/faChevronDown";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons/faChevronRight";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import {faComment} from "@fortawesome/free-solid-svg-icons/faComment";

export const loadIcons = () => {
  library.add(
    faSort,
    faEye,
    faSync,
    faBan,
    faTrash,
    faArrowUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faSave,
    faPlus,
    faPencilAlt,
    faUser,
    faTachometerAlt,
    faHeart,
    faList,
    faTasks,
    faBook,
    faHdd,
    faLock,
    faSignInAlt,
    faSignOutAlt,
    faWrench,
    faThList,
    faUserPlus,
    faAsterisk,
    faFlag,
    faBell,
    faHome,
    faRoad,
    faCloud,
    faTimesCircle,
    faSearch,
    faRedo,
    faMoneyCheckAlt,
    faCopy,
    faClipboardCheck,
    faMoneyCheck,
    faFolder,
    faQuestionCircle,
    faSortUp,
    faSortDown,
    faAmbulance,
    faExclamationTriangle,
    faClock,
    faCaretUp,
    faCaretDown,
    faCheckCircle,
    faCar,
    faPhoneAlt,
    faMapMarker,
    faBus,
    faCalendarAlt,
    faHospital,
    faTimes,
    faCheck,
    faChevronDown,
    faChevronRight,
    faMapMarkerAlt,
    faComment
  );
};
